import React, { FC } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';
import classNames from 'classnames';

export interface Props {
  heading: string;
  errors: string[] | undefined;
  classes?: string;
}

const ErrorList: FC<{ errors: string[] }> = ({ errors }) => {
  return (
    <ul className="mt-2 pl-4">
      {errors?.map((err, index) => (
        <li className="list-disc break-normal pb-1 font-bold" key={index}>
          {err}
        </li>
      ))}
    </ul>
  );
};

const Errors: FC<Props> = ({ errors, heading = '', classes = '' }) => {
  if (!errors || errors?.length < 1) {
    return null;
  }

  return (
    <div
      data-testid="error-container"
      className={classNames(
        classes,
        'container mx-auto mb-4 flex h-fit w-full gap-5 break-words border border-warning bg-red-tint p-5 text-warning md:w-fit',
      )}
    >
      <div className="basis-8">
        <AiOutlineWarning size={40} />
      </div>
      <div>
        <p>{heading}</p>
        <ErrorList errors={errors} />
      </div>
    </div>
  );
};

export default React.memo(Errors);
